// Date <-> ISO-day-string helpers for the Assessment Performance period
// pickers. The backend expects `YYYY-MM-DD` (dash) strings, so periods are
// stored in that format.
//
// CRITICAL: serialization and deserialization MUST both use LOCAL date
// components. `new Date('2026-05-02')` parses a dash-only date string as
// UTC midnight (per the ECMAScript spec); the calendar then renders it in
// local time, which shifts the day BACK by one in negative-UTC-offset
// timezones (e.g. the Americas). That asymmetry — local serialize via
// `isoDay`, UTC deserialize via `new Date(str)` — was the "pick May 2,
// Apply shows May 1" bug. `parseIsoDay` is the symmetric inverse of
// `isoDay`: both speak local time, so the round-trip is timezone-stable.

/** Date -> 'YYYY-MM-DD' using LOCAL components. */
export const isoDay = date => {
  if (!date) return '';
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, '0');
  const d = String(date.getDate()).padStart(2, '0');
  return `${y}-${m}-${d}`;
};

/**
 * 'YYYY-MM-DD' -> local-midnight Date (inverse of isoDay). Returns null for
 * falsy/malformed input. Do NOT replace with `new Date(str)` — that parses
 * a dash-date as UTC and reintroduces the off-by-one in the Americas.
 */
export const parseIsoDay = s => {
  if (!s) return null;
  const [y, m, d] = String(s).split('-').map(Number);
  if (!y || !m || !d) return null;
  return new Date(y, m - 1, d);
};
